import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "9e14255b-72d4-4845-98d7-0be4ebed53a5", content: `(0,0)`, options: {} },
  { id: "31140132-9a41-48ad-b247-0fc2b0984db7", content: `(±2,0)`, options: {} },
  { id: "76c59f2f-a555-4d4e-868e-ee544887790b", content: `(0,1)`, options: {} },
  { id: "e0d50d69-c171-4e28-91af-d9e23344e890", content: `(±1,0)`, options: {} },
  { id: "6690758e-f6fc-47ef-b5bb-1aac5a650a07", content: `(±3,0)`, options: {} },
  { id: "71cfd890-19f1-4a10-8158-5147a964ec79", content: `(0,2)`, options: {} },
  { id: "41cdbadc-3806-4625-8871-3323db43d91c", content: `(±2,1)`, options: {} },
  { id: "b81fe7d4-1839-4a75-b57f-c9dea39db626", content: `(±1,2)`, options: {} },
  { id: "9e75f032-36d0-4c69-8142-d74de1eec5f8", content: `(±1,1)`, options: {} },
  { id: "dcdc4524-6984-481b-8358-503b8df80052", content: `(0,3)`, options: {} },
];

const groups = [
  { id: "37f43ff5-f305-4f7a-a79a-847756b50baf", content: "Propagating modes", options: {} },
  { id: "d391960c-e5db-45d0-a0a4-414bfec349d2", content: "Evanescent modes", options: {} },
];

export const task: Task = {
  id: "556674e5-5472-49a8-97ae-2cdff815b184",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
    orientation: "horizontal",
    sectionItemsAmount: 2,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "37f43ff5-f305-4f7a-a79a-847756b50baf",
      itemsId: [
        "9e14255b-72d4-4845-98d7-0be4ebed53a5",
        "31140132-9a41-48ad-b247-0fc2b0984db7",
        "76c59f2f-a555-4d4e-868e-ee544887790b",
        "e0d50d69-c171-4e28-91af-d9e23344e890",
        "6690758e-f6fc-47ef-b5bb-1aac5a650a07",
      ],
    },
    {
      groupId: "d391960c-e5db-45d0-a0a4-414bfec349d2",
      itemsId: [
        "71cfd890-19f1-4a10-8158-5147a964ec79",
        "41cdbadc-3806-4625-8871-3323db43d91c",
        "b81fe7d4-1839-4a75-b57f-c9dea39db626",
        "9e75f032-36d0-4c69-8142-d74de1eec5f8",
        "dcdc4524-6984-481b-8358-503b8df80052",
      ],
    },
  ],
};
